<template>
  <div class="chat-interface flex flex-col md:flex-row h-[87dvh]" :class="currentTheme === 'telegram' ? 'bg-[#17212b]' : 'bg-[#111b21]'">
    <!-- Theme Toggle -->
    <!-- <div class="theme-toggle absolute top-2 right-2 z-10">
      <div class="flex items-center bg-opacity-80 rounded-full p-1" :class="currentTheme === 'telegram' ? 'bg-[#232e3c]' : 'bg-[#222e35]'">
        <button 
          @click="setTheme('telegram')" 
          class="flex items-center justify-center rounded-full p-2 transition-all"
          :class="currentTheme === 'telegram' ? 'bg-[#2b5278] text-white' : 'text-gray-400'"
        >
          <Send class="size-4" />
        </button>
        <button 
          @click="setTheme('whatsapp')" 
          class="flex items-center justify-center rounded-full p-2 transition-all"
          :class="currentTheme === 'whatsapp' ? 'bg-[#00a884] text-white' : 'text-gray-400'"
        >
          <MessageCircle class="size-4" />
        </button>
      </div>
    </div> -->

    <!-- Left side: Chat List -->
    <div 
      v-if="chats" 
      class="chat-list-container w-full md:w-[360px] flex-shrink-0 border-r flex flex-col"
      :class="[
        currentTheme === 'telegram' ? 'border-[#232e3c]' : 'border-[#222e35]',
        (selectedChat && isMobileView) ? 'hidden md:flex' : 'flex'
      ]"
    >
      <!-- Header -->
      <div 
        class="header p-3 flex items-center justify-between border-b"
        :class="currentTheme === 'telegram' ? 'bg-[#17212b] border-[#232e3c]' : 'bg-[#202c33] border-[#222e35]'"
      >
        <div class="flex-1 flex items-center relative">
          <Search :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'" class="size-4 mr-2 absolute left-3" />
          <input 
            v-model="searchQuery"
            @keydown.enter="reloadAndGetAll({ page: '1', search: searchQuery })" 
            class="ps-10 search-bar rounded-md text-sm py-2 px-4 w-full focus:outline-none" 
            :class="currentTheme === 'telegram' ? 'bg-[#232e3c] placeholder:text-[#8a9aa9]' : 'bg-[#222e35] placeholder:text-[#aebac1]'"
            placeholder="Pesquisar"
          />
          <button 
            v-if="searchQuery" 
            @click="clearSearch" 
            class="absolute right-2 hover:text-white"
            :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'"
          >
            <X class="size-4" />
          </button>
        </div>
      </div>

      <!-- Chat List -->
      <div class="chats-container flex-1 overflow-y-auto">
        <!-- No chats found message -->
        <div 
          v-if="chats.data.length === 0 && isSearchActive" 
          class="empty-search-results flex flex-col items-center justify-center h-full p-6 text-center"
        >
          <div 
            class="empty-search-icon rounded-full p-5 mb-4"
            :class="currentTheme === 'telegram' ? 'bg-[#232e3c]' : 'bg-[#222e35]'"
          >
            <SearchX :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'" class="size-10" />
          </div>
          <h3 class="text-white text-lg font-medium mb-2">Nenhum chat encontrado</h3>
          <p :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'" class="text-sm mb-4">
            Não encontramos nenhum resultado para "{{ searchQuery }}"
          </p>
          <button 
            @click="clearSearch" 
            class="text-white py-2 px-4 rounded-md text-sm transition-colors"
            :class="currentTheme === 'telegram' ? 'bg-[#2b5278] hover:bg-[#3a6ea5]' : 'bg-[#00a884] hover:bg-[#029670]'"
          >
            Limpar pesquisa
          </button>
        </div>
        
        <!-- Empty state when no chats exist -->
        <div 
          v-else-if="chats.data.length === 0 && !isSearchActive" 
          class="empty-chats flex flex-col items-center justify-center h-full p-6 text-center"
        >
          <div 
            class="empty-chats-icon rounded-full p-5 mb-4"
            :class="currentTheme === 'telegram' ? 'bg-[#232e3c]' : 'bg-[#222e35]'"
          >
            <MessageSquare :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'" class="size-10" />
          </div>
          <h3 class="text-white text-lg font-medium mb-2">Nenhum chat disponível</h3>
          <p :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'" class="text-sm">
            Você ainda não possui conversas
          </p>
        </div>
        
        <!-- Chat list items -->
        <template v-else>
          <div 
            v-for="(chat, index) in chats.data" 
            :key="index" 
            class="chat-item flex items-center p-3 cursor-pointer border-b last:border-b-0"
            :class="[
              currentTheme === 'telegram' 
                ? [
                    'border-[#232e3c]', 
                    selectedChat?.id === chat.id ? 'bg-[#2b5278]' : 'hover:bg-[#232e3c]'
                  ] 
                : [
                    'border-[#222e35]', 
                    selectedChat?.id === chat.id ? 'bg-[#2a3942]' : 'hover:bg-[#222e35]'
                  ]
            ]"
            @click="selectedChat?.id !== chat.id && selectChat(index)"
          >
            <!-- Avatar -->
            <div class="avatar-container relative">
              <div 
                class="avatar rounded-full size-12 flex items-center justify-center text-white font-bold"
                :class="getAvatarColorClass(chat.lead.firstName)"
              >
                {{ getInitials(chat.lead.firstName) }}
              </div>
            </div>
  
            <!-- Chat Info -->
            <div class="chat-info flex-1 ml-3 overflow-hidden">
              <div class="flex justify-between items-center">
                <h3 class="text-white font-medium truncate">{{ chat.lead.firstName }}</h3>
                <span 
                  :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'" 
                  class="text-xs whitespace-nowrap" 
                  v-if="chat.updatedAt"
                >
                  {{ new Date(chat.updatedAt).toLocaleString() }}
                </span>
              </div>
              
              <div class="flex justify-between items-center mt-1">
                <div class="flex items-center max-w-[85%] text-xs text-zinc-400">
                  <!-- Message preview would go here -->
                  <p style="
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">
                    {{ chat.lastMessage }}
                  </p>
                </div>
                
                <!-- Unread count -->
                <div 
                  v-if="chat.unreadMessagesCount" 
                  class="rounded-full size-6 flex items-center justify-center flex-shrink-0"
                  :class="currentTheme === 'telegram' ? 'bg-[#64b3f4]' : 'bg-[#00a884]'"
                >
                  <span class="text-white text-xs font-medium">{{ chat.unreadMessagesCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- Bottom Navigation -->
      <div 
        class="bottom-nav border-t p-3 flex justify-between items-center"
        :class="currentTheme === 'telegram' ? 'bg-[#17212b] border-[#232e3c]' : 'bg-[#202c33] border-[#222e35]'"
      >
        <Pagination 
          class="mt-0" 
          @update:page="page => reloadAndGetAll({ page, search: isSearchActive ? searchQuery : undefined })" 
          v-if="chats?.pagination && chats.data.length > 0" 
          :data="chats?.pagination" 
        />
      </div>
    </div>
    <TelegramChatsSkeleton v-else />

    <!-- Right side: Chat Preview -->
    <div 
      class="chat-preview-container flex-1"
      :class="(!selectedChat && isMobileView) ? 'hidden md:block' : 'block'"
    >
      <template v-if="!isChatLoading">
        <TelegramMessagePreview
          class="min-h-full"
          v-if="selectedChat"
          @go-back="selectedChat = undefined"
          :sender="selectedChat.lead.firstName"
          :messages="getChatMessages(selectedChat)"
          :sentAt="selectedChat.updatedAt"
          :showAvatar="true"
          @send-message="handleSendMessage"
          :disableMic="true"
          :disableAttachments="true"
          :theme="currentTheme"
        />
        <div 
          v-else 
          class="h-full flex items-center justify-center"
          :class="currentTheme === 'telegram' ? 'text-[#8a9aa9]' : 'text-[#aebac1]'"
        >
          <div class="text-center">
            <MessageCircle class="size-16 mx-auto mb-4 opacity-30" />
            <p class="text-lg">Selecione um chat para ver a conversa</p>
          </div>
        </div>
      </template>
      <TelegramChatSkeleton :sender="'Lead'" v-if="isChatLoading" :theme="currentTheme" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'
import { 
  Menu, 
  Search,
  SearchX,
  X,
  CheckCircle2, 
  Check, 
  CheckCheck, 
  Video, 
  Image as ImageIcon, 
  Volume2, 
  Pin, 
  Users, 
  MessageCircle,
  MessageSquare,
  Settings,
  ArrowLeft,
  Send
} from 'lucide-vue-next'
import TelegramMessagePreview from '@/components/ui/telegram/TelegramMessagePreview.vue'
import { useChat } from '@/composables/useChat'
import { Chat } from '@/interfaces/chats/Chat'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { ChatMessageSender } from '@/enums/chats/messages/ChatMessageSender'
import { ChatMessageTypeEnum } from '@/enums/chats/messages/ChatMessageTypeEnum'
import TelegramChatSkeleton from '@/components/ui/telegram/TelegramChatSkeleton.vue'
import TelegramChatsSkeleton from '@/components/ui/telegram/TelegramChatsSkeleton.vue'
import { useWebSocket } from '@/composables/useWebSocket'
import Pagination from '@/components/ui/pagination/Pagination.vue'

const route = useRoute()
const webSocket = computed(() => useWebSocket({ page: 1 }))
const chats = ref<IPagination<Chat>>()
const isChatLoading = ref(false)
const { getAll: getAllChats, getByUuid: getChatByUuid, read: readMessages, send: sendMessage } = useChat()
const socket = ref<typeof webSocket.value>()
const page = ref<string>('10')
// Selected chat state
const selectedChat = ref<Chat>()
// Search state
const searchQuery = ref('')
const isSearchActive = ref(false)
// Theme state (telegram or whatsapp)
const currentTheme = ref('telegram')
// Responsive state
const isMobileView = ref(false)

// Set theme function
// const setTheme = (theme: 'telegram' | 'whatsapp') => {
//   currentTheme.value = theme
// }

// Function to check if the view is mobile
const checkMobileView = () => {
  isMobileView.value = window.innerWidth < 768
}

// Function to select a chat
const selectChat = async (index: number) => {
  const chatInList = chats.value!.data[index]
  if (chatInList.unreadMessagesCount! > 0) {
    readMessages(chatInList.id)
  }
  isChatLoading.value = true
  const chat = await getChatByUuid(chatInList!.uuid)
  chats.value!.data[index].unreadMessagesCount = 0
  selectedChat.value = { ...chat, lead: chatInList!.lead }
  isChatLoading.value = false
}

// Helper functions
const getInitials = (name: string): string => {
  if (!name) return 'U'
  return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)
}

const getAvatarColorClass = (name: string): string => {
  // Generate a consistent color based on the name
  const colors = [
    'bg-[#e17076]', // red
    'bg-[#7bc862]', // green
    'bg-[#65aadd]', // blue
    'bg-[#a695e7]', // purple
    'bg-[#ee7aae]', // pink
    'bg-[#6ec9cb]', // teal
    'bg-[#faa774]'  // orange
  ]
  
  // Simple hash function to get a consistent index
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  
  const index = Math.abs(hash) % colors.length
  return colors[index]
}

// Function to get messages for the chat preview component
const getChatMessages = (chat: Chat) => {
  return chat.messages?.map((msg) => {
    let text = msg.content
    let type: any = msg.type
    let copyable = false
    let isRedirectLink = false

    if (msg.type === ChatMessageTypeEnum.URL_BUTTON || msg.type === ChatMessageTypeEnum.ACTION_BUTTON) {
      type = 'button'
    }

    if (msg.type === ChatMessageTypeEnum.URL_BUTTON) {
      isRedirectLink = true
    }

    if (msg.type === ChatMessageTypeEnum.COPYABLE_TEXT) {
      type = 'text'
      copyable = true
    }

    if (msg.type === ChatMessageTypeEnum.QR_CODE) {
      type = 'image'
      text = '/assets/bot/pix/qr-code-example.jpg'
    }

    if (msg.type === ChatMessageTypeEnum.DOCUMENT) {
      type = 'document'
    }

    if (msg.type === ChatMessageTypeEnum.LOCATION) {
      type = 'text'
      text = '📍 Localização enviada'
    }

    return { text, source: msg.type === ChatMessageTypeEnum.IMAGE || msg.type === ChatMessageTypeEnum.VIDEO || msg.type === ChatMessageTypeEnum.DOCUMENT ? msg.content : undefined, type, isFromAuthUser: msg.sender === ChatMessageSender.BOT, copyable, sentAt: msg.createdAt, isRedirectLink }
  }) || [
    { type: 'text' as const, text: chat.lastMessage }
  ]
}

async function handleSendMessage(content: string) {
  // selectedChat.value?.messages?.push({
  //   content,
  //   type: ChatMessageTypeEnum.TEXT,
  //   sender: ChatMessageSender.BOT,
  //   createdAt: new Date()
  // })
  await sendMessage(selectedChat.value!.uuid, { content, type: ChatMessageTypeEnum.TEXT })
}

function reloadAndGetAll({ page, search }: { page: string, search?: string }) {
  socket.value?.emit('paginate_chats', page)
  isSearchActive.value = !!search && search.trim() !== ''
  
  getAllChats({ page, search })
    .then((data) => chats.value = data)
}

function clearSearch() {
  searchQuery.value = ''
  isSearchActive.value = false
  reloadAndGetAll({ page: '1' })
}

watch(() => selectedChat.value, () => {
  nextTick(() => {
      if (selectedChat.value && window.innerWidth < 768) {
        document.querySelector('.mobile-bottom-navigation')!.classList.add('hidden')
      } else {
        document.querySelector('.mobile-bottom-navigation')!.classList.remove('hidden')
      }
    })
})

onMounted(() => {
  const initialSearch = route.query.search as string | undefined
  if (initialSearch) {
    searchQuery.value = initialSearch
    isSearchActive.value = true
    getAllChats({ search: initialSearch }).then((data) => chats.value = data)
  } else {
    getAllChats().then((data) => chats.value = data)
  }

  // socket must be initialized regardless of initial search
  socket.value = webSocket.value

  socket.value.on("new_message", (data) => {
    console.log(data,'nova mensagem')
    const chatIndex = chats.value?.data.findIndex(chat => chat.id === data.chat.id) 

    if (selectedChat.value && data.chat.id == selectedChat?.value?.id) {
      // inserir a mensagem na variavel
      selectedChat.value.messages?.push(data)

      readMessages(selectedChat.value.id)

      if (chatIndex !== undefined && chatIndex >= 0) {
        chats.value!.data[chatIndex].unreadMessagesCount = 0
      }

      // descer para a última mensagem
      nextTick(() => {
        const chatContainer = document.querySelector('#messages-container');
        if (chatContainer) {
          // Move o scroll para o final
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      });
    } else if (chatIndex !== undefined && chatIndex >= 0) {
      chats.value!.data[chatIndex].unreadMessagesCount! += 1
    }

    if (chatIndex !== undefined && chatIndex >= 0) {
      chats.value!.data[chatIndex].lastMessage = data.content
    }
  });

  socket.value.on('new_chat', (chat) => {
    chats.value?.data.push(chat)
  })

  // Check if mobile view on mount
  checkMobileView()
  
  // Add resize event listener
  window.addEventListener('resize', checkMobileView)
})

onUnmounted(() => {
  if (socket.value) {
    socket.value.close()
  }
  
  // Remove resize event listener
  window.removeEventListener('resize', checkMobileView)
})
</script>

<style scoped>
.chats-container::-webkit-scrollbar {
  width: 6px;
}

.chats-container::-webkit-scrollbar-track {
  background: v-bind('currentTheme === "telegram" ? "#17212b" : "#111b21"');
}

.chats-container::-webkit-scrollbar-thumb {
  background: v-bind('currentTheme === "telegram" ? "#232e3c" : "#222e35"');
  border-radius: 3px;
}

.chat-item {
  transition: background-color 0.2s;
}

.empty-search-icon, .empty-chats-icon {
  transition: transform 0.2s ease;
}

.empty-search-results:hover .empty-search-icon,
.empty-chats:hover .empty-chats-icon {
  transform: scale(1.05);
}

/* Animation for empty states */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.empty-search-results, .empty-chats {
  animation: fadeIn 0.3s ease-out;
}

.theme-toggle {
  transition: all 0.3s ease;
}

/* Mobile-specific styles */
@media (max-width: 768px) {
  .chat-interface {
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    right: 0;
  }
  
  .theme-toggle {
    top: 0.5rem;
    right: 0.5rem;
  }
}
</style>